module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-8"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), (_vm.msgStatus == 21) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("暂缓登记")]) : _vm._e(), _vm._v(" "), (_vm.msgStatus == 3) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.querys.bookName))])]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "150px"
      }
    }, [(term.code != 501) ? _c('span', [(!_vm.modifyFlag) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 2)
        }
      }
    }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && term.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && term.status != 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (term.code == 501) ? _c('span', [(_vm.pubStatus == 1 || _vm.pubStatus == 0) ? _c('UpBtn', {
      attrs: {
        "fileID": _vm.zeroStoreage[term.id] ? _vm.zeroStoreage[term.id].fileId : '',
        "btnProps": Object.assign({}, term),
        "pubStatus": (term.name == '整改报告' && _vm.pubStatus == 0 && _vm.isModifyStage == '1') ||
          (term.name != '整改报告' && _vm.pubStatus == 0) ?
          0 :
          1
      },
      on: {
        "zeroTabStore": _vm.zeroStoreCtrls
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "3"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : _vm._e(), _vm._v(" "), (term.code == '501') ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "3"
      }
    }, [_vm._v(" ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabTips"
  }, [_vm._v("注：上传整改报告文件格式为WORD，文件大小不超过100M")])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "ssPressDiag",
    attrs: {
      "title": "选择需要拷贝的表",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.checkList.length > 0) ? _c('div', [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n        数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。\n      ")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.codeArr),
      callback: function($$v) {
        _vm.codeArr = $$v
      },
      expression: "codeArr"
    }
  }, _vm._l((_vm.checkList), function(tab, index) {
    return _c('div', {
      staticClass: "selectItem"
    }, [_c('el-checkbox', {
      key: tab.id,
      attrs: {
        "label": tab.materialCode
      }
    }, [_vm._v(_vm._s(tab.materialCode.substr(2, 3)) + " " + _vm._s(tab.materialTitle))])], 1)
  }))], 1) : _c('div', {
    staticClass: "errors"
  }, [_vm._v("目前尚未生成可拷贝的表")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.checkList.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('act')
      }
    }
  }, [_vm._v("拷 贝")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37cc33df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/SuccessivePart/successiveTabs.vue
// module id = 1712
// module chunks = 1